<template>
    <div class="my-4 ma-md-5 mx-lg-10 mx-xl-10 maxw-1750">
      <h2>{{ $t('views.calltome.title') }}</h2>
      <v-card class="mt-4">
        <v-form v-model="valid" @submit.prevent="submitForm">
          <v-row class="pa-md-0 pa-2 ma-md-0 ma-2 mt-md-1">
            <v-col cols="12">
              <h2>{{ $t('views.calltome.subtitle')}}</h2>
            </v-col>
            <v-col cols="12">
              <p>{{ $t('views.calltome.check')}}
                <router-link
                  to="/profile/edit"> {{ $t('views.calltome.profile')}}</router-link>
                {{ $t('views.calltome.always')}}.</p>
            </v-col>
            <v-col>
              <v-col xs="12" sm="5" md="4" lg="3" class="container__input">
                <v-text-field
                  :label="$t('views.calltome.text')"
                  v-model="telefono"
                  outlined
                  required
                  :rules="[rules.required, rules.digital]"
                  @click:clear="onClearClicked"
                  :clearable="true"
                  ></v-text-field>
              </v-col>

              <p>{{ $t('views.calltome.service')}}.</p>
              <p>{{ $t('views.calltome.cause')}}
                <a
                  href="https://web.sas.junta-andalucia.es/servicioandaluzdesalud/politica-de-privacidad"
                  target="_blank">{{ $t('views.calltome.policy') }}</a>.
              </p>
            </v-col>
            <v-col cols="12">
              <div class="btn__send d-flex justify-end">
                <v-btn
                  :disabled="!valid"
                  color="primary"
                  type="submit">{{ $t('views.calltome.btn')}}</v-btn>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'CallToMeView',
  computed: {
    ...mapState({
      user: ({ session: { session } }) => (session != null ? session.user : null),
    }),
  },
  data() {
    return {
      rules: {
        required: (value) => !!value || this.$t('validation.required'),
        digital: (value) => (value && (value.length === 6 || value.length === 9)) || this.$t('validation.tel'),
      },
      valid: false,
      telefono: '',
      dni: '',
      id: '',
      userid: '',
      nombreApp: 'MCS',
    };
  },
  methods: {
    async submitForm() {
      const idOrquestador = '40c4a960-b078-40e4-9545-b14e4dcce796';

      const messageId = await this.$store.dispatch('messages/createNotificationMessage', {
        icon: 'progress-circular',
        title: this.$t('views.calltome.msg.send'),
      });

      try {
        await this.dashboardClient.callToMe({
          apiCges: {
            delegado: this.userid,
            endpoint: `centralita/orquestadores/${ idOrquestador }/procesos/llamadas/contactame`,
          },
          telefono: this.telefono,
          nombreApp: this.nombreApp,
          dni: this.dni,
        });

        this.$store.dispatch('messages/updateMessage', {
          id: messageId,
          title: this.$t('views.calltome.msg.ok'),
          icon: 'mdi-check',
          type: 'success',
          timeout: this.$getConst('notifications.timeout'),
        });
      } catch (error) {
        console.log(error);

        this.$store.dispatch('messages/updateMessage', {
          id: messageId,
          title: this.$t('views.calltome.msg.ko'),
          icon: 'mdi-times',
          type: 'error',
          timeout: this.$getConst('notifications.timeout'),
        });
      }
    },
    onClearClicked() {
      this.telefono = '';
    },
    isCitizen() {
      return this.user.hasIosUser();
    },
  },
  async created() {
    if (this.isCitizen()) {
      this.$store.dispatch('messages/createNotificationMessage', {
        title: 'No tienes acceso para visualizar este módulo',
        type: 'error',
        timeout: this.$getConst('notifications.timeoutPlus'),
        dismissible: true,
      });

      this.$router.push('/');
    } else {
      this.dashboardClient = this.$api.getClient('dashboard');

      const {
        mobilePhone,
        dni,
        id,
        userid,
      } = this.user;

      this.telefono = mobilePhone;
      this.id = id;
      this.dni = dni;
      this.userid = userid;
    }
  },
};
</script>
<style lang="scss" scoped>
  .container__input {
    padding: 0;
  }
  .btn__send {
    padding-right: 48px;
  }
  @media (max-width: 600px) {
    .btn__send {
      padding-right: 0;
    }
    .btn__send button {
      width: 100%;
    }
  }
</style>
